import Vue from 'vue'
// import axios from "axios"
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

export const state = () => ({
  state: {
    mainLoading: false,
  }
})

export const mutations = {
  UPDATE_MAIN_LOADING: (state, payload) => {
    state.mainLoading = payload
  },
}

export const actions = {
  setMainLoading(context, payload) {
    context.commit('UPDATE_MAIN_LOADING', payload)
  }
}
export const getters = {
  getMainLoading: state => {
    return state.mainLoading
  }
}

export default {
  state,
  actions,
  mutations,
getters}
